import Select from 'react-select'

const ServiceGroupSelector = ({ serviceGroups, setServiceGroup, isLoading }) => {
    return (
        <Select
            options={serviceGroups.map(e => ({ label: e, value: e }))}
            onChange={e => { setServiceGroup(undefined); setServiceGroup(e.value) }}
            placeholder="Select a Service Group to view its archived services."
            isLoading={isLoading}
            loadingMessage={() => "Loading service groups..."}
            noOptionsMessage={() => "No service groups found"}
        />
    )
}

export default ServiceGroupSelector